<template lang="pug">
vm-prompt(vm-size="medium" @vm-cancel="close" @vm-accept="saveInvoice" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
  vm-row(v-if="!isAddNew" class="section-invoice" vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveInvoice, push: true, focus: true, disabled: $v.form.$invalid },]")
    vm-col(class="section-invoice__titles", vm-align="center", vm-w=6)
      h3 {{ $t('strings.supplier') }}: {{ form.supplier.name }}
    vm-col(class="section-invoice__titles", vm-align="center", vm-w=6)
      h3 {{ $t('strings.total_invoice') }}: {{ maxValue | currency }}
  vm-row(v-else class="section-invoice" vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveInvoice, push: true, focus: true, disabled: $v.form.$invalid },]")
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      vm-select(autocomplete :placeholder='$t("purchase_orders.supplier_placeholder")' v-model="form.supplier" :label='$t("purchase_orders.supplier_display")')
        vm-select-item(:key="index" :value="item" :text="item.name" v-for="(item,index) in suppliers")
    vm-col(class="section-invoice__titles", vm-align="center", vm-w=6)
      h3 {{ $t('strings.total_invoice') }}: {{ maxValue | currency}}
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12 class="section-inputs")
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      b-form-group
        vm-input(autofocus :placeholder='$t("supplier_invoices.invoice_number_placeholder")' :danger="$v.form.invoice_number.$invalid && $v.form.invoice_number.$model" :danger-text="$t('validation.required', { attribute: $t('supplier_invoices.invoice_number') })" v-model="form.invoice_number" :label='$t("supplier_invoices.invoice_number")')
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      b-form-group
        vm-input(:disabled="!form.supplier_id" type="currency" autofocus :placeholder='$t("supplier_invoices.amount_placeholder")' :danger="$v.form.total.$invalid && $v.form.total.$model" :danger-text="$t('validation.required', { attribute: $t('supplier_invoices.total') })" v-model="form.total" :label='$t("supplier_invoices.total")')
    vm-col(vm-justify="center", vm-align="center", vm-w=4)
      b-form-group
       label.vm-input--label {{ $t('quotations.currency') }}
       .radio-section
         .radio-item(v-for='(currency, index) in currencies' :key="index")
           input.radio-margin(type="radio" :value="currency.id" :id="currency.id" v-model="form.currency_id")
           label.radio-label(:for="currency.id") {{ currency.code }}
    vm-col(vm-justify="center", vm-align="center", vm-w=4)
      b-form-group
        label.vm-input--label {{ $t('quotations.tax_type') }}
        .radio-section
          .radio-item
            input.radio-margin(type="radio" value=0 id="tax_0" v-model="form.tax_type")
            label.radio-label(for="tax_0") 0%
          .radio-item
            input.radio-margin(type="radio" value=.08 id="tax_8" v-model="form.tax_type")
            label.radio-label(for="tax_8") 8%
          .radio-item
            input.radio-margin(type="radio" value=.16 id="tax_16" v-model="form.tax_type")
            label.radio-label(for="tax_16") 16%
    vm-col(vm-justify="center", vm-align="center", vm-w=4)
      b-form-group
        vm-date-picker.filter(type="date" :label="$t('supplier_invoices.invoice_date')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :danger="$v.form.invoice_date.$invalid && $v.form.invoice_date.$model" :danger-text="$t('validation.required', { attribute: $t('supplier_invoices.invoice_date') })" :value="form.invoice_date" v-model="form.invoice_date")
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required, maxValue } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('SupplierInvoices')

export default {
  name: 'ModalSupplierInvoices',
  mixins: [ModalMixin1],
  props: {
    supplier: {
      type: Object,
      default: () => ({})
    },
    isAddNew: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    currencies: [
      { code: 'MXN', id: 1 },
      { code: 'USD', id: 2 }
    ],
    maxValue: ''
  }),
  validations () {
    return {
      form: {
        supplier_id: {
          required
        },
        invoice_number: {
          required
        },
        total: {
          required,
          maxValue: maxValue(this.maxValue)
        },
        currency_id: {
          required
        },
        tax_type: {
          required
        },
        invoice_date: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'catalog', 'suppliers'])
  },
  watch: {
    'form.supplier' (supplier) {
      this.form.supplier_id = supplier.id
      this.maxValue = supplier.total_amount
    },
    'form.total' (total) {
      this.form.tax_amount = total * this.form.tax_type
      this.form.subtotal = parseFloat(total) - +parseFloat(this.form.tax_amount)
    },
    'form.tax_type' (tax) {
      this.form.tax_amount = this.form.total * tax
      this.form.subtotal = parseFloat(this.form.total) - +parseFloat(this.form.tax_amount)
    },
    isModalVisible (flag) {
      if (!this.isAdd) { this.handleChange(this.form.invoice_date) }
      if (flag) { this.loadSuppliers() }
    }
  },
  methods: {
    ...mapActions([
      'addInvoice',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog',
      'loadSuppliers'
    ]),
    saveInvoice () {
      this.isAdd ? this.addInvoice(this.form) : this.editRecord(this.form)
    },
    handleChange (date) {
      this.form.invoice_date = date
    }
  }
}
</script>
<style lang="scss">
.section-invoice {
  padding: 10px;
}
.section-inputs {
  margin: 5px;
  .vm-datepicker {
    margin-left: 5px;
  }
  .vm-input {
    margin: 5px;
  }
}
.radio-section {
  display: flex;
  .radio-item {
    margin: 5px 15px;
  }
}
</style>
